import { Grid, Typography } from '@mui/material';
import { MprcContainer } from 'components';
import { ITrainingViewDto, TrainingViewDto } from 'generated/CoreApi_v1';
import { Formaters } from 'lib/Formaters';
import { useTranslation } from 'react-i18next';
import { TrainingViewAwardBox, TrainingViewCertificateBox, TrainingViewDurationBox, TrainingViewEndExecutionBox, TrainingViewInstructorsBox, TrainingViewRegistrationBox, TrainingViewStartExecutionBox } from 'views/lms/training/components/TrainingViewBoxes';

export const RegistrationDefaultHighlights = (props: ITrainingViewDto | null) => {

    return props == null
        ? null
        : (
            <Grid container justifyContent="flex-start" alignItems="flex-start" width="100%" rowSpacing={3} columnSpacing={2} >

                {
                    (props.registrationEnrollAvailableFrom || props.registrationEnrollAvailableUntil) &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewRegistrationBox {...props} />
                    </Grid>
                }

                <Grid size={{ xs: 4 }}>
                    <TrainingViewStartExecutionBox {...props} />
                </Grid>

                {
                    (props.executionDueDays || props.executionDueDate) &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewEndExecutionBox dueDate={props.executionDueDate} dueDays={props.executionDueDays} />
                    </Grid>
                }

                {
                    props.trainingDurationFormated &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewDurationBox {...props} />
                    </Grid>
                }

                {
                    props.instructors != null && props.instructors.length > 0 &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewInstructorsBox instructors={props.instructors} />
                    </Grid>
                }

                {
                    props.generateCertificate &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewCertificateBox {...props} />
                    </Grid>
                }

                {
                    ((props.awardApprovalPoints ?? 0) > 0 || (props.awardEnrollPoints ?? 0) > 0) &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewAwardBox
                            awardApprovalPoints={props.awardApprovalPoints ?? 0}
                            awardEnrollPoints={props.awardEnrollPoints ?? 0}
                        />
                    </Grid>
                }
            </Grid>
        );
};

export const RegistrationResumeHighlights = (props: TrainingViewDto) => {
    const { t } = useTranslation("lms");
    const { trainingDurationFormated, publishedOn, modifiedOn, author } = props;

    return props == null || (!trainingDurationFormated && !publishedOn && !author)
        ? null
        : (
            <MprcContainer>
                <Typography variant="h5" color="black">
                    {t("Training.Literals.TrainingDetailsText")}
                </Typography>
                <Typography variant="caption">
                    {trainingDurationFormated &&
                        <>
                            {t("Training.Literals.DurationText")} {trainingDurationFormated}
                        </>
                    }
                    {
                        publishedOn &&
                        <>
                            &nbsp;&bull;&nbsp;
                            {t("Training.Literals.PublishedOnText")} {Formaters.performaDate(publishedOn, { preposition: "auto", excludeTime: true, replaceClosestDays: true })}
                            {modifiedOn && ` (${t("Training.Literals.ModifiedOnText").toLocaleLowerCase()} ${Formaters.performaDate(modifiedOn, { preposition: "auto", replaceClosestDays: true })}) `}
                        </>
                    }
                    {
                        author &&
                        <>
                            &nbsp;&bull;&nbsp;
                            {t("Training.Literals.AuthorText")}: {author}
                        </>
                    }
                </Typography>
            </MprcContainer>
        );
};
